import { IonContent, IonPage } from '@ionic/react';
import React from 'react';

import { Logo, Padding, PageMeta } from '@/components/common';

import './Legal.css';

const DeleteAccount = () => {
  return (
    <IonPage>
      <PageMeta title="Account Deletion - Odonto" />
      <IonContent>
        <Padding>
          <Logo navigateToRootOnClick />
          <div className="container">
            <h1 className="legal__title">ACCOUNT DELETION</h1>
            <p className="legal__paragraph">Last updated: 11/10/2024</p>
            <h2 className="legal__section-title">1. Introduction</h2>
            <p className="legal__paragraph">
              Welcome to Odonto! This page provides information on how to
              request the deletion of your account.
            </p>
            <h2 className="legal__section-title">
              2. Steps to Request Account Deletion
            </h2>
            <p className="legal__paragraph">
              To request the deletion of your account, please follow these
              steps:
            </p>
            <ul className="list">
              <li className="list-item">
                Log in to your account on our website.
              </li>
              <li className="list-item">
                Navigate to the account settings page.
              </li>
              <li className="list-item">
                Click on the "Delete Account" button.
              </li>
              <li className="list-item">
                Follow the on-screen instructions to confirm your request.
              </li>
            </ul>
            <h2 className="legal__section-title">
              3. Data Deletion and Retention
            </h2>
            <p className="legal__paragraph">
              Upon account deletion, the following data will be permanently
              removed:
            </p>
            <ul className="list">
              <li className="list-item">
                Personal information such as name and phone number.
              </li>
              <li className="list-item">
                Usage data associated with your account.
              </li>
            </ul>
            <p className="legal__paragraph">
              Some data may be retained for a period of time to comply with
              legal obligations or for legitimate business purposes.
            </p>
            <h2 className="legal__section-title">4. Contact Us</h2>
            <p className="legal__paragraph">
              If you have any questions about account deletion, please contact
              us:
            </p>
            <ul className="list">
              <li className="list-item">
                By email:{' '}
                <a href="mailto:hello@odonto.ph" target="_blank">
                  hello@odonto.ph
                </a>
                .
              </li>
              <li className="list-item">
                By visiting this page on our website:{' '}
                <a href="https://www.odonto.ph/help" target="_blank">
                  https://www.odonto.ph/help
                </a>
              </li>
            </ul>
          </div>
        </Padding>
      </IonContent>
    </IonPage>
  );
};

export default DeleteAccount;
